export const VALIDATION_REQUIRED = 'validation.required';
export const VALIDATION_POSITIVE_NUMBER = 'validation.positiveNumber';
export const VALIDATION_NIF_NOT_VALID = 'validation.nifNotValid';
export const VALIDATION_MORE_THAN_ZERO = 'validation.moreThanZero';
export const VALIDATION_IS_GREATHER = 'validation.isGreater';
export const VALIDATION_PASSWORD_MISMATCHED = 'validation.passwordMismatched';
export const VALIDATION_NOT_EMAIL_TYPE = 'validation.notEmailType';
export const VALIDATION_MAX_THREE_DECIMALS = 'validation.maxThreeDecimals';
